import { checkIsEqual, compareTwoValue } from 'designer/component/action/Data'
import objectPath from 'object-path'
import { calTotal } from './Total'
import { isEmpty } from 'designer/component/action/condition/State'

export const createJsonTable = (
  jsonTable = [],
  { designContext, uischema, stateParent },
) => {
  const {
    tableData: [tableData, setTableData],
    totalCount: [totalCount, setTotalCount],
  } = stateParent
  let { jsonForm, tabParamActive } = designContext
  let formData = jsonForm.formData
  let { tableColumn = [], loadData } = uischema

  const filterTabParam = loadData.filterTabParam
  const elementTableColumn = tableColumn.filter(
    ({ valueType }) => valueType === 'element',
  )

  if (Array.isArray(jsonTable)) {
    let filterSetting = objectPath.get(uischema, 'loadData.filterTable')
    jsonTable = jsonTable.filter((table) => {
      if (filterSetting && filterSetting.length > 0) {
        if (table === undefined) return
        let isPassList = []
        filterSetting.forEach(
          ({ filterType, compareType, conditionValue, refColumnId, field }) => {
            let valueA = objectPath.get(table, refColumnId)
            if (filterType === 'system') {
              let fieldKey = field?.key
              conditionValue = objectPath.get(formData, fieldKey)
            }
            let check = compareTwoValue(compareType, valueA, conditionValue)
            isPassList.push(check)
          },
        )
        let isPassed = isPassList.includes(false) ? false : true
        return isPassed
      }
      return table !== undefined
    })
    jsonTable.map((table, index) => {
      elementTableColumn.forEach((item) => {
        let { receiveKey, field } = item
        if (receiveKey) {
          let elementValue = objectPath.get(jsonForm.formData, receiveKey)
          objectPath.set(table, field, elementValue)
        }
      })
      if (table) {
        objectPath.set(table, 'tableData.no', index + 1)
      }
      return table
    })
    if (filterTabParam) {
      let paramName = filterTabParam.name
      let tabKey = filterTabParam.tabKey
      let filterJsonTable = jsonTable.filter((rowData) => {
        let activeTab = objectPath.get(tabParamActive, tabKey)
        let tabParam = activeTab.find((active) => active.name === paramName)
        if (tabParam) {
          let tabValue = tabParam.value
          let rowValue = objectPath.get(rowData, paramName)
          return checkIsEqual(rowValue, tabValue)
        }
        return false
      })
      jsonTable = filterJsonTable
    }

    let replaceDetailColumn = tableColumn.filter(
      ({ typeField, valueType }) =>
        typeField === 'system' && valueType === 'replacePanel',
    )
    replaceDetailColumn.forEach(({ field, replacePanel }) => {
      let { replaceField, replaceTable } = replacePanel

      if (replaceField && replaceTable) {
        jsonTable.map((rowData) => {
          let replaceValue = objectPath.get(rowData, field)
          if (Array.isArray(replaceValue)) {
            let destination = []
            replaceValue.forEach((replaceRowValue) => {
              let newValue = {}
              replaceTable.forEach(
                ({ key, replaceKey, defaultValue, isEmptyInvisible }) => {
                  let value = objectPath.get(replaceRowValue, replaceKey)
                  if (value === undefined) {
                    value = defaultValue
                  }
                  if (isEmptyInvisible && isEmpty(value)) {
                    objectPath.set(newValue, '@skipRow', true)
                  }
                  objectPath.set(newValue, key, value)
                },
              )
              let skipRow = objectPath.get(newValue, '@skipRow')
              if (!skipRow) {
                destination.push(newValue)
              }
            })
            objectPath.set(rowData, replaceField, destination)
          }
          return rowData
        })
      }
    })

    setTableData(jsonTable)
    setTotalCount(jsonTable.length)
    calTotal(jsonTable, { designContext, uischema })
  }
}
